export const findRootPredicateUuid = (predicates) => {
    return Object.values(predicates).find(({ criteriaTypeDTO }) => typeof criteriaTypeDTO !== 'undefined')?.uuid;
};

export const findPredicateById = ({ predicates, predicateId }) =>
    Object.values(predicates).find((predicate) => {
        return (
            predicate.predicateId === predicateId && ['Predicate', 'PredicateGroup'].includes(predicate.predicateType)
        );
    });
